import classNames from 'classnames';

export const FilterItem = ({
  active,
  href,
  onClick,
  children,
  className,
  rightText,
  truncate,
  disabled,
}) => {
  const defaultProps = {
    href: 'javascript:;',
    className: classNames(
      'FilterItem',
      { active, truncate, disabled },
      className,
    ),
  };

  if (active || disabled) {
    // it is important that the active link has no events / href on it.
    return (
      <a {...defaultProps}>
        <span className="FilterItem--primary">{children}</span>
        <span className="FilterItem--secondary">{rightText}</span>
        <span className="FilterItem--secondary FilterItem--arrow">▾</span>
      </a>
    );
  } else {
    // do NOT prevent event bubbling
    return (
      <a {...defaultProps} onClick={onClick} href={href}>
        <span className="FilterItem--primary">{children}</span>
        <span className="FilterItem--secondary">{rightText}</span>
      </a>
    );
  }
};
FilterItem.defaultProps = {
  rightText: '   ',
};
